export default __webpack_public_path__ + "static/media/placeholder_dummy2016-goldschmiede01-de.8b5b7d69.png";